import React from "react";
import {
  LegendRowStyled, LegendItemsStyled, LegendActionsStyled, LegendLabelStyled, LegendItemStyled, LegendDotStyled,
} from "../orgDesign.styles";
import { getLegendStatuses, getRoleChangeConfig } from "../orgDesign.constants";

// Every status the backend/tree engine actually supports (STATUS_LABELS'
// own keys — see orgDesignTreeEngine.js's STATUSES), minus FUSED for a
// Current Org workspace, which never has one (see getLegendStatuses) — no
// future/unsupported role type is introduced here. Each dot's color comes from
// getRoleChangeConfig, the same lookup driving every tree node's own accent
// border + status tag, so the legend can never drift out of sync with what
// the nodes actually show. `entryOption` swaps AUGMENTED's label to
// "Increased" for a from-scratch (existing-org) workspace — see
// getRoleChangeConfig. `actions` (Org View's own controls, e.g. the Layout
// switch) sit on the right of the same row.
const RoleChangeLegend = ({ entryOption, actions }) => (
  <LegendRowStyled>
    <LegendItemsStyled>
      <LegendLabelStyled>Role Changes</LegendLabelStyled>
      {getLegendStatuses(entryOption).map((status) => {
        const config = getRoleChangeConfig(status, entryOption);
        return (
          <LegendItemStyled key={status}>
            <LegendDotStyled $accentToken={config.accentToken} />
            {config.label}
          </LegendItemStyled>
        );
      })}
    </LegendItemsStyled>
    {actions && <LegendActionsStyled>{actions}</LegendActionsStyled>}
  </LegendRowStyled>
);

export default RoleChangeLegend;
